import { useEffect, useState } from "react";
import { api } from "../api/client";
import { Link } from "react-router-dom";

interface Watchlist {
  id: string;
  name: string;
  symbols: string[];
  created_at: number;
  updated_at: number;
}

export function Watchlist() {
  const [lists, setLists] = useState<Watchlist[]>([]);
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);

  async function load() {
    try {
      const data = await api<Watchlist[]>("/v1/watchlists");
      setLists(data);
    } catch (e) {
      setError((e as Error).message);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function createList() {
    if (!name.trim()) return;
    await api("/v1/watchlists", { method: "POST", body: { name, symbols: [] } });
    setName("");
    load();
  }

  async function removeList(id: string) {
    await api(`/v1/watchlists/${id}`, { method: "DELETE" });
    load();
  }

  return (
    <div className="page">
      <h1>Watchlists</h1>
      {error && <div className="error">{error}</div>}
      <div className="form-row">
        <input
          placeholder="New watchlist name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <button type="button" className="btn btn-primary" onClick={createList}>
          Create
        </button>
      </div>
      <div className="list-grid">
        {lists.map((wl) => (
          <div key={wl.id} className="list-card">
            <div className="list-card-header">
              <h3>{wl.name}</h3>
              <button type="button" className="btn btn-ghost btn-sm" onClick={() => removeList(wl.id)}>
                Remove
              </button>
            </div>
            <div className="list-card-symbols">
              {wl.symbols.length === 0 && <span className="muted">No symbols yet</span>}
              {wl.symbols.map((s) => (
                <Link key={s} to={`/trade/${s}`} className="chip">
                  {s}
                </Link>
              ))}
            </div>
          </div>
        ))}
        {lists.length === 0 && <div className="muted">No watchlists yet.</div>}
      </div>
    </div>
  );
}
